import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { Constant } from 'src/app/Common/constant';
import { LocalStorageService } from 'src/app/Model/Common/LocalStorageService';
import { APIFactoryEndPoints } from 'src/app/Model/Common/apifactory-end-points';
import { ErrorLog } from 'src/app/Model/Common/error-log';
import { AllDeliveryDetailsDto } from 'src/app/Model/Shipping/all-delivery-details-dto';
import { BankPayment } from 'src/app/Model/Shipping/bank-payment';
import { CardPayment } from 'src/app/Model/Shipping/card-payment';
import { CashPayment } from 'src/app/Model/Shipping/cash-payment';
import { CommonPayments } from 'src/app/Model/Shipping/common-payments';
import { CouponPayment } from 'src/app/Model/Shipping/coupon-payment';
import { GatewayPayment } from 'src/app/Model/Shipping/gateway-payment';
import { PaytmPaymentDto } from 'src/app/Model/Shipping/paytm-payment-dto';
import { SwipePayment } from 'src/app/Model/Shipping/swipe-payment';
import { TransactionDetailPaymentsDto } from 'src/app/Model/Shipping/transaction-detail-payments-dto';
import { TransactionSummary } from 'src/app/Model/Shipping/transaction-summary';
import { UpiPayment } from 'src/app/Model/Shipping/upi-payment';
import { WalletPayment } from 'src/app/Model/Shipping/wallet-payment';
import { ToastrService } from 'src/app/Service/Common/toastr.service';
import { ShippingManagerService } from 'src/app/Service/Shipping/shipping-manager.service';
import { MultipleTransactionComponent } from '../multiple-transaction/multiple-transaction.component';
const { disableFileChhoserfunction } =require('src/myfunc.js')

@Component({
  selector: 'shipping-details',
  templateUrl: './shipping-details.component.html',
  styleUrls: ['./shipping-details.component.css']
})
export class ShippingDetailsComponent implements OnInit, OnDestroy {

  shipping: AllDeliveryDetailsDto = new AllDeliveryDetailsDto();
  invNo: string;
  shippingStatusForm: UntypedFormGroup;
  constant: Constant = new Constant();
  uploadedFile: File;
  uploadedSignURL: string;
  uploadImgDiv: boolean = false;
  paidAmount: number = 0;
  remainingAmt: number = 0;
  commonPayments: CommonPayments = new CommonPayments();
  transactionSummary: TransactionSummary = new TransactionSummary();
  voucherType: string = "Receipt";
  errorLog: ErrorLog = new ErrorLog();

  //Subscription
  private uploadImgSubscription: Subscription;
  private saveReceiptSubscription: Subscription;
  private shippingDetailSubscription: Subscription;
  private insertErrorLogSubscription: Subscription;

  constructor(
    @Inject(MAT_DIALOG_DATA) public dialogData: any,
    private formBuilder: UntypedFormBuilder,
    private toastService: ToastrService,
    public persistenceService: LocalStorageService,
    private shippingManagerService: ShippingManagerService,
    public dialog: MatDialog,
    private apiFactory: APIFactoryEndPoints,
    public dialogRef: MatDialogRef<ShippingDetailsComponent>,
  ) {
    dialogRef.disableClose = true;
    this.invNo = dialogData.shippingData;
    console.log(this.invNo);
  }

  ngOnInit(): void {
    this.getShippingDetailsInvNo();
  }

  ngOnDestroy() {
    if (this.uploadImgSubscription !== undefined)
      this.uploadImgSubscription.unsubscribe();

    if (this.saveReceiptSubscription !== undefined)
      this.saveReceiptSubscription.unsubscribe();

    if (this.shippingDetailSubscription !== undefined)
      this.shippingDetailSubscription.unsubscribe();

    if (this.insertErrorLogSubscription !== undefined)
      this.insertErrorLogSubscription.unsubscribe();
  }

  getShippingDetailsInvNo() {
    this.shippingDetailSubscription = this.shippingManagerService.getShippingDetailsByInvNo(this.apiFactory.getDeliveryDetailsByInvNo, this.invNo).subscribe(data => {
      if (data.length > 0) {
        this.shipping = data[0];
        this.commonPayments.locationCode = this.shipping.locationCode;
        this.commonPayments.companyCode = this.shipping.companyCode;
        this.calculateAmount();
      }
      else {
        this.toastService.showErrorToast(this.constant.noDataAvailableToast);
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("getShippingDetailsInvNo", error);
      });
  }

  calculateAmount() {
    let finalAmt: number = Number(this.shipping.allOrdersForDeliveryDto.netAmt);
    let cashAmt: number = Number(this.shipping.allOrdersForDeliveryDto.cashPaid);
    let upiAmt: number = Number(this.shipping.allOrdersForDeliveryDto.upiPaid);
    let bankAmt: number = Number(this.shipping.allOrdersForDeliveryDto.bankPaid);
    let cardAmt: number = Number(this.shipping.allOrdersForDeliveryDto.cardPaid);
    let couponAmt: number = Number(this.shipping.allOrdersForDeliveryDto.couponPaid);
    let walletAmt: number = Number(this.shipping.allOrdersForDeliveryDto.walletPaid);
    let gatewayAmt: number = Number(this.shipping.allOrdersForDeliveryDto.gatewayPaid);
    let swipeAmt: number = Number(this.shipping.allOrdersForDeliveryDto.swipePaid);
    let paytmAmt: number = Number(this.shipping.allOrdersForDeliveryDto.paytmPaid);
    let deliveryCharge: number = Number(this.shipping.allOrdersForDeliveryDto.deliveryCharge);
    let total_amt_byAllTypes: number = cashAmt + upiAmt + bankAmt + cardAmt + couponAmt +
            walletAmt + gatewayAmt + swipeAmt + paytmAmt - deliveryCharge;
    this.paidAmount = Number((finalAmt - total_amt_byAllTypes).toFixed(2));
    this.remainingAmt = Number(this.paidAmount);

    // if (this.shipping.allOrdersForDeliveryDto.cashPaid >= finalAmt) {
    //   this.paidAmount = this.shipping.allOrdersForDeliveryDto.cashPaid;
    // }
    // else if (this.shipping.allOrdersForDeliveryDto.upiPaid >= finalAmt) {
    //   this.paidAmount = this.shipping.allOrdersForDeliveryDto.upiPaid;
    // }
    // else if (this.shipping.allOrdersForDeliveryDto.cardPaid >= finalAmt) {
    //   this.paidAmount = this.shipping.allOrdersForDeliveryDto.cardPaid;
    // }
    // else if (this.shipping.allOrdersForDeliveryDto.bankPaid >= finalAmt) {
    //   this.paidAmount = this.shipping.allOrdersForDeliveryDto.bankPaid;
    // }
    // else if (this.shipping.allOrdersForDeliveryDto.couponPaid >= finalAmt) {
    //   this.paidAmount = this.shipping.allOrdersForDeliveryDto.couponPaid;
    // }
    // else {
    //   if (this.shipping.allOrdersForDeliveryDto.cashPaid > 0)
    //     this.paidAmount = finalAmt - this.shipping.allOrdersForDeliveryDto.cashPaid;

    // }
  }

  onPaymentClick() {
    let dialogRef = this.dialog.open(MultipleTransactionComponent, {
      width: '50%',
      height: '80%',
      minWidth: '350px',
      data: { amt: this.paidAmount.toFixed(2), trnsactionDto: this.commonPayments }
    });
    dialogRef.afterClosed().subscribe(data => {
      this.commonPayments = data.data;
      if (this.commonPayments.amount >= this.paidAmount) {
        // this.remainingAmt = this.commonPayments.amount - this.paidAmount;
        this.onPaymentSaveClick();
      } else {
        this.remainingAmt = this.paidAmount - this.commonPayments.amount;
      }
    });
  }

  onPaymentSaveClick() {
    let momentDate = new Date();
    let formattedDate = moment(momentDate).format("YYYY-MM-DD HH:mm:ss");

    this.transactionSummary.fromLocationCode = this.shipping.locationCode;
    this.transactionSummary.voucherType = this.voucherType;
    this.transactionSummary.transactionDate = formattedDate;
    this.transactionSummary.documentRefNo = this.shipping.assignedDeliveryDto.invNo;

    this.transactionSummary.transactionDetailPayments = [];

    let element = new TransactionDetailPaymentsDto();
    element.headOfAccount = this.shipping.customerDto.customerName;
    element.ledgerCode = this.shipping.customerDto.refNo;
    element.ledgerType = "Customer";
    element.amount = this.paidAmount;

    if (this.commonPayments.cashPayment.amount > 0) {
      element.cashPayment = new CashPayment();
      element.cashPayment.amount = this.commonPayments.cashPayment.amount;
      element.cashPayment.type = this.voucherType;
      element.cashPayment.fromLocationCode = this.shipping.locationCode;

      this.transactionSummary.narration = "Being Paid on Delivery by Cash";
    }

    if (this.commonPayments.upiPayment.amount > 0) {
      element.upiPayment = new UpiPayment();
      element.upiPayment.amount = this.commonPayments.upiPayment.amount;
      element.upiPayment.fromLocationCode = this.shipping.locationCode;
      element.upiPayment.upiPaymentDetails = this.commonPayments.upiPayment.upiPaymentDetails;

      this.transactionSummary.narration = "Being Paid on Delivery by Upi";
    }

    if (this.commonPayments.paytmPayment.amount > 0) {
      element.paytmPayment = new PaytmPaymentDto();
      element.paytmPayment.amount = this.commonPayments.paytmPayment.amount;
      element.paytmPayment.fromLocationCode = this.shipping.locationCode;
      element.paytmPayment.linkId = this.commonPayments.paytmPayment.linkId;
      element.paytmPayment.orderId = this.commonPayments.paytmPayment.orderId;
      element.paytmPayment.customerCode = this.commonPayments.paytmPayment.customerCode;

      this.transactionSummary.narration = "Being Paid on Delivery by Paytm";
    }

    if (this.commonPayments.bankPayment.amount > 0) {
      element.bankPayment = new BankPayment();
      element.bankPayment.amount = this.commonPayments.bankPayment.amount;
      element.bankPayment.type = this.voucherType;
      element.bankPayment.bankPaymentDetails = this.commonPayments.bankPayment.bankPaymentDetails;

      this.transactionSummary.narration = "Being Paid on Delivery by Bank";
    }

    if (this.commonPayments.cardPayment.amount > 0) {
      element.cardPayment = new CardPayment();
      element.cardPayment.amount = this.commonPayments.cardPayment.amount;
      element.cardPayment.bankAccountCode = this.commonPayments.cardPayment.bankAccountCode;
      element.cardPayment.fromLocationCode = this.shipping.locationCode;
      element.cardPayment.cardPaymentDetails = this.commonPayments.cardPayment.cardPaymentDetails;

      this.transactionSummary.narration = "Being Paid on Delivery by Card";
    }

    if (this.commonPayments.couponPayment.amount > 0) {
      element.couponPayment = new CouponPayment();
      element.couponPayment.amount = this.commonPayments.couponPayment.amount;
      element.couponPayment.fromLocationCode = this.shipping.locationCode;
      element.couponPayment.couponPaymentDetails = this.commonPayments.couponPayment.couponPaymentDetails;

      this.transactionSummary.narration = "Being Paid on Delivery by Coupon";
    }

    if (this.commonPayments.walletPayment.amount > 0) {
      element.walletPayment = new WalletPayment();
      element.walletPayment.amount = this.commonPayments.walletPayment.amount;
      element.walletPayment.type = "Payment";
      element.walletPayment.fromLocationCode = this.shipping.locationCode;
      element.walletPayment.appliedOfferList = this.commonPayments.walletPayment.appliedOfferList;
    }

    if (this.commonPayments.swipePayment.amount > 0) {
      element.swipePayment = new SwipePayment();
      element.swipePayment.amount = this.commonPayments.swipePayment.amount;
      element.swipePayment.fromLocationCode = this.shipping.locationCode;
      element.swipePayment.swipePaymentResponseCode = this.commonPayments.swipePayment.swipePaymentResponseCode;
      element.swipePayment.paymentType = this.commonPayments.swipePayment.paymentType;
    }

    if (this.commonPayments.gatewayPayment.amount > 0) {
      element.gatewayPayment = new GatewayPayment();
      element.gatewayPayment.amount = this.commonPayments.gatewayPayment.amount;
      element.gatewayPayment.fromLocationCode = this.shipping.locationCode;
      element.gatewayPayment.gatewayPaymentResponseCode = this.commonPayments.gatewayPayment.gatewayPaymentResponseCode;
      element.gatewayPayment.paymentType = this.commonPayments.gatewayPayment.paymentType;
    }

    this.transactionSummary.transactionDetailPayments.push(element);

    this.transactionSummary.module = this.constant.SHIPPING;
    this.saveReceiptSubscription = this.shippingManagerService.insertSubGroupAcc2(this.apiFactory.insertReceiptVoucher, this.transactionSummary).subscribe((data: any) => {
      this.toastService.showSuccessToast(this.constant.paymentSuccessToast);
      this.remainingAmt = this.commonPayments.amount - this.paidAmount;
      this.commonPayments = new CommonPayments();
      this.getShippingDetailsInvNo();
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("onPaymentSaveClick", error);
      });
  }

  handleFileInput(files: FileList) {

    if (files[0].size > this.constant.uploadFileSize)
      alert(this.constant.fileBigSize);
    else {
      this.uploadedFile = files.item(0);
      this.uploadImgDiv = true;

      var reader = new FileReader();
      reader.onload = (event: any) => {
        this.uploadedSignURL = event.target.result;
      }
      reader.readAsDataURL(files.item(0));
    }
  }
  fileChooserAndroid(sourceType:string)
  {
    disableFileChhoserfunction(sourceType)
  }
  removeImg() {
    this.uploadImgDiv = false;
  }

  uploadImgClick() {
    this.uploadImgSubscription = this.shippingManagerService.uploadImage(this.apiFactory.uploadImgForShipping, this.shipping.assignedDeliveryDto.invNo, this.uploadedFile).subscribe((response:any) => {
      if (response.data) {
        this.toastService.showSuccessToast(this.constant.imageUploadToast);
      }
    },
      (error: HttpErrorResponse) => {
        this.insertErrorLog("uploadImgClick", error);
      });
  }

  insertErrorLog(errorMethod: string, error: HttpErrorResponse) {
    this.errorLog.userId = this.persistenceService.get('userId');
    this.errorLog.dateAndTime = moment(new Date()).format(this.constant.dateTimeFormatForDBServer);
    this.errorLog.moduleName = "Shipping Manager";
    this.errorLog.errorMethod = errorMethod;
    this.errorLog.platform = "Web";
    if (error?.error?.message|| error?.error?.message!= '')
      this.errorLog.errorDetails = error.error.message;
    else
      this.errorLog.errorDetails = error.message;

    // this.insertErrorLogSubscription = this.containerService.insertErrorLog(this.apiFactory.insertErrorLog, this.errorLog).subscribe((data: any) => {
    // });
  }

}

